import React from 'react'
import LoadingMessage from '../../../components/LoadingMessage'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { withJob } from 'react-jobs'

import { bindPromiseCreators } from '../../../utils/routines'

import { withApplicationsReducer } from '../reducer'
import { withFetchAllApplysSaga } from '../saga'
import { selectLoginTokenData } from '../../Login/selectors'
import { selectUserSortedApplications } from '../selectors'
import { createFetchAllApplysPromise } from '../routines'
import ApplicationsList from './ApplicationsList'

const mapStateToProps = createStructuredSelector({
  user: selectLoginTokenData,
  applications: selectUserSortedApplications
})
const mapDispatchToProps = bindPromiseCreators({
  fetchApplications: createFetchAllApplysPromise
})
const connector = connect(mapStateToProps, mapDispatchToProps)

const work = ({ fetchApplications, user: { id }, applications }) => {
  // if has fectched applications no refetch
  if (applications.length) return true

  return fetchApplications(id)
}
const LoadingComponent = () => (
  <LoadingMessage>
    Recuperando últimas solicitudes
  </LoadingMessage>
)

const job = withJob({
  work,
  LoadingComponent
})

export default compose(
  withApplicationsReducer,
  withFetchAllApplysSaga,
  connector,
  job
)(ApplicationsList)
